import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-base-auth',
	templateUrl: './base-auth.component.html',
	styleUrls: ['./base-auth.component.scss']
})
export class BaseAuthComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
